import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "mc mt10"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  class: "centered w100",
  style: {"padding-top":"10px"}
}
const _hoisted_5 = {
  class: "mc",
  style: {"width":"800px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs24 mt20",
  style: {}
}, "その他設定", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mt40" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl mr10",
  style: {}
}, "公開ページURL", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fl grey" }, "https://waaq.jp/p/", -1)
const _hoisted_15 = {
  class: "fl grey",
  style: {}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fl grey" }, "/", -1)
const _hoisted_17 = {
  class: "fl ml2",
  style: {"width":"180px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "fl mt20 text-left"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: `use_noindex_`,
  class: "fs13"
}, "noindexを設定する", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "grey fs12" }, "（検索エンジンによる表示がされなくなります）", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { class: "mt20" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "フォーム表示タイミング", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = { class: "fl ml20" }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "フォーム入力後の日程候補の表示設定", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = { class: "text-left" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600" }, "ルールを設定", -1)
const _hoisted_48 = {
  key: 1,
  class: "fl withEditable fw600 posRe lskyblueBg rad8 pointer fs12 hoverLgreyBg pad15",
  style: {"margin-top":"20px"}
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = { class: "w100 withEditable posRe lskyblueBg rad8 fs12 hoverLgreyBg pad5 mt20 mb20" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = {
  key: 1,
  class: "fl mt20 text-left w100"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "フォーム入力完了時の表示", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = { class: "w100 centered" }
const _hoisted_60 = { class: "centered fs12 pad40" }
const _hoisted_61 = { class: "fw600 ddgrey fs14" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = { class: "fl mt20 text-left" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "送信先チャネル", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, " 送信先にメール送信とSMS送信を選べます。メール送信の場合はメールアドレスを、SMS送信の場合は電話番号をフォームに必ず含めてください。 ", -1)
const _hoisted_74 = { key: 0 }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "fl" }, "メールアドレスのみ", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_81 = { class: "fl mt20 text-left" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "オーナー宛通知先を変更", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, " 通常確定時にはオーナー宛にメールを送信します。オーナーのメールアドレスではないメールアドレスに通知先を設定したい場合はこちらに入力ください。 ", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsTabContent = _resolveComponent("SettingsTabContent")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_RoomSettingsUseChatContent = _resolveComponent("RoomSettingsUseChatContent")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_AvailableScheduleRulesContent = _resolveComponent("AvailableScheduleRulesContent")!
  const _component_ThanksPage = _resolveComponent("ThanksPage")!
  const _component_PublicSettingsAttachmentFilesContent = _resolveComponent("PublicSettingsAttachmentFilesContent")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_RoomDetailSettings = _resolveComponent("RoomDetailSettings")!
  const _component_RoomSettingsInstantRoom = _resolveComponent("RoomSettingsInstantRoom")!
  const _component_RoomSettingsAvailableTime = _resolveComponent("RoomSettingsAvailableTime")!
  const _component_InputGroupNamespaceModal = _resolveComponent("InputGroupNamespaceModal")!
  const _component_ScheduleRuleModal = _resolveComponent("ScheduleRuleModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rcm && _ctx.rcm.room)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("section", {
                style: {},
                class: _normalizeClass(`mt20 rad20 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad40'}`)
              }, [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_SettingsTabContent, {
                  selectedTabName: _ctx.selectedTabName,
                  selectTab: _ctx.selectTab
                }, null, 8, ["selectedTabName", "selectTab"]),
                (_ctx.selectedTabName == `public`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        (_ctx.rm.userInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              (_ctx.rm.namespace)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "fl lgreyBg rad6 pointer fs12 dgrey",
                                    style: {"padding":"5px 14px"},
                                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNamespaceModal && _ctx.openNamespaceModal(...args)))
                                  }, " 現在の企業URL: " + _toDisplayString(_ctx.rm.namespace), 1))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "fl pinkBg rad6 pointer fs12",
                                    style: {"padding":"5px 14px"},
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNamespaceModal && _ctx.openNamespaceModal(...args)))
                                  }, " 企業URLを設定してください "))
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_13,
                        _createElementVNode("div", null, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.rm.namespace), 1),
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_MdTextfieldTag, {
                              fieldStyle: "min-width:180px;",
                              style: {"height":"56px","margin-top":"-24px"},
                              class: "fl fs16",
                              type: `page_key`,
                              placeholder: `フォームの名前（半角英数字+記号）`,
                              value: _ctx.rcm.room.page_key || ``,
                              onInputValue: _ctx.inputPageKey,
                              maxLength: 50,
                              min: 3,
                              required: ""
                            }, null, 8, ["value", "onInputValue"])
                          ]),
                          _hoisted_18
                        ])
                      ]),
                      _hoisted_19,
                      _hoisted_20,
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_CheckboxTag, {
                              value: ``,
                              name: `use_noindex`,
                              checked: _ctx.rcm.room.use_noindex,
                              prefix: `use_noindex`,
                              onClickCheckbox: _ctx.clickUseNoindex,
                              style: {"margin-left":"1px","margin-right":"7px"}
                            }, null, 8, ["checked", "onClickCheckbox"]),
                            _hoisted_22,
                            _hoisted_23
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      (_ctx.showChatContent)
                        ? (_openBlock(), _createBlock(_component_RoomSettingsUseChatContent, {
                            key: 1,
                            class: "fl mt20 text-left"
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _hoisted_32,
                        _createVNode(_component_SelectTag, {
                          name: "display_form_timing_type",
                          id: "select_display_form_timing_type",
                          class: "fl fs14 roundForm mt20",
                          style: {"min-width":"130px","height":"50px","width":"300px"},
                          options: _ctx.SelectUtil.selectFormTimingTypes.map(t => t.name),
                          defaultOption: _ctx.getDefaultTimingType(),
                          onSelectValue: _ctx.selectTimingType
                        }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(_ctx.getTimingImage()),
                            height: "100"
                          }, null, 8, _hoisted_34)
                        ]),
                        _hoisted_35,
                        _hoisted_36,
                        (_ctx.rcm.room.display_form_timing_type == `open_page`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _hoisted_38,
                              _hoisted_39,
                              _createElementVNode("p", _hoisted_40, [
                                _createTextVNode(" 先にフォームを表示した場合に、日程調整を表示するルールを設定できます。 "),
                                (_ctx.rcm.room.display_schedule_type == `rules`)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "ルールが設定されていない場合、「常に表示する」と同じ状態になります。"))
                                  : (_ctx.rcm.room.display_schedule_type == `rules_by_ai`)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, "複数の調整カレンダーの中から、マニュアルに沿って調整カレンダーを自動で選択し候補を表示します。"))
                                    : _createCommentVNode("", true)
                              ]),
                              _hoisted_43,
                              _createVNode(_component_SelectTag, {
                                name: "display_schedule_type",
                                id: "select_display_schedule_type",
                                class: "fl fs14 roundForm mt20 mr20",
                                style: {"min-width":"130px","height":"50px","width":"380px"},
                                options: _ctx.SelectUtil.displayScheduleTypes.map(t => t.name),
                                defaultOption: _ctx.getDefaultDisplayScheduleType(),
                                onSelectValue: _ctx.selectDisplayScheduleType
                              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                              _hoisted_44,
                              (_ctx.rcm.room.display_schedule_type == `rules`)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    (_ctx.Util.isBlank(_ctx.rcm.room.rule))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "fl pad15 pointer",
                                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addRule && _ctx.addRule(...args)))
                                        }, [
                                          _createElementVNode("img", {
                                            src: _ctx.$getAssetImageUrl(`/assets/icons/round_plus.png`),
                                            width: "37",
                                            height: "40"
                                          }, null, 8, _hoisted_46),
                                          _hoisted_47
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.rcm.room.rule && _ctx.Util.isPresent(_ctx.ruleText))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                          _createTextVNode(_toDisplayString(_ctx.ruleText) + "のときに、日程を提示します。 ", 1),
                                          _createElementVNode("span", {
                                            class: "skyblueBg rad5 pointer",
                                            style: {"padding":"5px 10px"},
                                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addRule && _ctx.addRule(...args)))
                                          }, "変更")
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.rcm.room.display_schedule_type == `rules_by_ai`)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _hoisted_50,
                                      _createElementVNode("div", _hoisted_51, [
                                        _createVNode(_component_AvailableScheduleRulesContent),
                                        _hoisted_52
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                              _hoisted_53
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_54,
                        _hoisted_55,
                        (_ctx.showEditThanksPage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _hoisted_57,
                              _hoisted_58,
                              _createElementVNode("div", _hoisted_59, [
                                (_ctx.RoomSetting.isRedirectUrl(_ctx.rcm.room))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "rad8 mt20 posRe ThanksPageEdit withEditable centered",
                                      style: {"height":"100px","border":"1px solid #efefef"},
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.editThanksPage && _ctx.editThanksPage(...args)))
                                    }, [
                                      _createElementVNode("p", _hoisted_60, [
                                        _createTextVNode(" リダイレクト: "),
                                        _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.rcm.room_setting.thanks_page.redirect_url_after_send), 1)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "rad8 mt20 posRe ThanksPageEdit withEditable text-left",
                                      style: {"border":"1px solid #f1f1f1"},
                                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.editThanksPage && _ctx.editThanksPage(...args)))
                                    }, [
                                      _createVNode(_component_ThanksPage, {
                                        room: _ctx.rcm.room,
                                        class: "pad40"
                                      }, null, 8, ["room"])
                                    ]))
                              ]),
                              _hoisted_62
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_63,
                        _hoisted_64,
                        (_ctx.showEditThanksPage)
                          ? (_openBlock(), _createBlock(_component_PublicSettingsAttachmentFilesContent, { key: 2 }))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_65,
                      _hoisted_66,
                      _hoisted_67,
                      _hoisted_68,
                      _hoisted_69,
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", null, [
                          _hoisted_71,
                          _hoisted_72,
                          _hoisted_73,
                          (!_ctx.canSendSMS)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                _hoisted_75,
                                _withDirectives(_createVNode(_component_IconLock, {
                                  class: "fl ml15",
                                  style: {"margin-top":"1px"},
                                  width: 16
                                }, null, 512), [
                                  [_directive_tooltip, `SMS送信を利用する場合は、担当者にお問い合わせください。`]
                                ])
                              ]))
                            : (_openBlock(), _createBlock(_component_SelectTag, {
                                key: 1,
                                name: "send_channel_type",
                                id: "select_send_channel_type",
                                class: "fl fs14 roundForm",
                                style: {"min-width":"130px","height":"50px"},
                                options: _ctx.SelectUtil.selectSendChannelTypes.map(t => t.name),
                                defaultOption: _ctx.getSendChannelType,
                                onSelectValue: _ctx.selectSendChannelType
                              }, null, 8, ["options", "defaultOption", "onSelectValue"])),
                          _hoisted_76
                        ]),
                        _hoisted_77
                      ]),
                      _hoisted_78,
                      _hoisted_79,
                      _hoisted_80,
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", null, [
                          _hoisted_82,
                          _hoisted_83,
                          _hoisted_84,
                          _createVNode(_component_MdTextfieldTag, {
                            fieldStyle: "width:320px;",
                            style: {"height":"56px","margin-top":"-12px"},
                            class: "fl fs16",
                            type: `owner_email_instead`,
                            placeholder: `通知先メールアドレスを入力`,
                            value: _ctx.rcm.room_setting.instead_of_owner_email || ``,
                            onInputValue: _ctx.inputInsteadOfOwnerEmail
                          }, null, 8, ["value", "onInputValue"]),
                          _hoisted_85
                        ]),
                        _hoisted_86
                      ]),
                      _hoisted_87,
                      _createVNode(_component_RoomDetailSettings, {
                        from: `public_room`,
                        editProviderEvent: _ctx.editProviderEvent
                      }, null, 8, ["editProviderEvent"])
                    ]))
                  : (_ctx.selectedTabName == `instant_room`)
                    ? (_openBlock(), _createBlock(_component_RoomSettingsInstantRoom, { key: 1 }))
                    : (_openBlock(), _createBlock(_component_RoomSettingsAvailableTime, {
                        key: 2,
                        onClickFixType: _ctx.clickFixType,
                        onSelectShowVoteType: _ctx.selectShowVoteType,
                        onSelectShowFilterVoteType: _ctx.selectShowFilterVoteType
                      }, null, 8, ["onClickFixType", "onSelectShowVoteType", "onSelectShowFilterVoteType"]))
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_InputGroupNamespaceModal, { onUpdateNamespace: _ctx.updateNamespace }, null, 8, ["onUpdateNamespace"]),
    _createVNode(_component_ScheduleRuleModal, {
      room: _ctx.rcm.room,
      onSaveRule: _ctx.saveRule
    }, null, 8, ["room", "onSaveRule"])
  ]))
}